/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attach_TitleInputs */

const cs_chat_attach_title = /** @type {(inputs: Chat_Attach_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přiložit ke zprávě`)
};

const en_chat_attach_title = /** @type {(inputs: Chat_Attach_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attach to message`)
};

/**
* | output |
* | --- |
* | "Attach to message" |
*
* @param {Chat_Attach_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_attach_title = /** @type {((inputs?: Chat_Attach_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attach_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_attach_title(inputs)
	return cs_chat_attach_title(inputs)
});